type Swatch =
  | "bg-orange-500"
  | "bg-green-500"
  | "bg-blue-500"
  | "bg-purple-500"
  | "bg-pink-500"
  | "bg-red-500"
  | "bg-yellow-500"
  | "bg-teal-500"
  | "bg-indigo-500"
  | "bg-lime-500"
  | "bg-slate-500"
  | "bg-amber-500"
  | "bg-emerald-500"
  | "bg-cyan-500"
  | "bg-sky-500"
  | "bg-violet-500"
  | "bg-fuchsia-500"
  | "bg-rose-500"
  | "bg-seagrass"
  | "bg-pomegranate"
  | "bg-carrot"
  | "bg-midnight-blue"
  | "bg-alizarin"
  | "bg-turquoise"
  | "bg-wisteria"
  | "bg-sienna"
  | "bg-cobalt"
  | "bg-magenta"
  | "bg-mauve"
  | "bg-olive"
  | "bg-crimson"
  | "bg-white";

type PaletteEntry = {
  bg: string;
  transparent?: string;
  gradientTop: string;
  gradientBottom: string;
  shoulder?: string;
  text: string;
};

const palette: Record<Swatch, PaletteEntry> = {
  ["bg-white"]: {
    // The "White" room is essentially uncoloured, so pastel tones don't apply. Use a light
    // warm grey (stone) for the header, and a deeper stone gradient on the booking bubble so
    // it stands out distinctly against the white calendar grid.
    bg: "bg-stone-300 dark:bg-stone-700",
    transparent: "bg-stone-500/5",
    gradientTop: "from-stone-200 dark:from-stone-600",
    gradientBottom: "to-stone-400 dark:to-stone-700",
    shoulder: "bg-gray-200 dark:bg-gray-700",
    text: "text-black dark:text-white",
  },
  ["bg-amber-500"]: {
    bg: "bg-amber-50 dark:bg-amber-900",
    transparent: "bg-amber-500/5",
    gradientTop: "from-amber-400",
    gradientBottom: "to-amber-600",
    shoulder: "bg-amber-200",
    text: "text-white",
  },
  ["bg-orange-500"]: {
    bg: "bg-orange-50 dark:bg-orange-900",
    transparent: "bg-orange-500/5 dark:bg-orange-500/10",
    gradientTop: "from-orange-400 dark:from-orange-600",
    gradientBottom: "to-orange-600 dark:to-orange-700",
    shoulder: "bg-orange-200 dark:bg-orange-700",
    text: "text-white dark:text-black",
  },
  ["bg-green-500"]: {
    bg: "bg-green-50",
    transparent: "bg-green-500/5",
    gradientTop: "from-green-400",
    gradientBottom: "to-green-600",
    shoulder: "bg-green-200",
    text: "text-white",
  },
  ["bg-blue-500"]: {
    bg: "bg-blue-50",
    transparent: "bg-blue-500/5",
    gradientTop: "from-blue-400",
    gradientBottom: "to-blue-600",
    shoulder: "bg-blue-200",
    text: "text-white",
  },
  ["bg-purple-500"]: {
    bg: "bg-purple-50",
    transparent: "bg-purple-500/5",
    gradientTop: "from-purple-400",
    gradientBottom: "to-purple-600",
    shoulder: "bg-purple-200",
    text: "text-white",
  },
  ["bg-pink-500"]: {
    bg: "bg-pink-50",
    transparent: "bg-pink-500/5",
    gradientTop: "from-pink-400",
    gradientBottom: "to-pink-600",
    shoulder: "bg-pink-200",
    text: "text-white",
  },
  ["bg-red-500"]: {
    bg: "bg-red-50",
    transparent: "bg-red-500/5",
    gradientTop: "from-red-400",
    gradientBottom: "to-red-600",
    shoulder: "bg-red-200",
    text: "text-white",
  },
  ["bg-yellow-500"]: {
    bg: "bg-yellow-50",
    transparent: "bg-yellow-500/5",
    gradientTop: "from-yellow-400",
    gradientBottom: "to-yellow-600",
    shoulder: "bg-yellow-200",
    text: "text-white",
  },
  ["bg-teal-500"]: {
    bg: "bg-teal-50",
    transparent: "bg-teal-500/5",
    gradientTop: "from-teal-400",
    gradientBottom: "to-teal-600",
    shoulder: "bg-teal-200",
    text: "text-white",
  },
  ["bg-indigo-500"]: {
    bg: "bg-indigo-50",
    transparent: "bg-indigo-500/5",
    gradientTop: "from-indigo-400",
    gradientBottom: "to-indigo-600",
    shoulder: "bg-indigo-200",
    text: "text-white",
  },
  ["bg-lime-500"]: {
    bg: "bg-lime-50",
    transparent: "bg-lime-500/5",
    gradientTop: "from-lime-400",
    gradientBottom: "to-lime-600",
    shoulder: "bg-lime-200",
    text: "text-white",
  },
  ["bg-slate-500"]: {
    bg: "bg-slate-50 dark:bg-slate-900",
    transparent: "bg-slate-500/5 dark:bg-slate-500/10",
    gradientTop: "from-slate-400 dark:from-slate-600",
    gradientBottom: "to-slate-600 dark:to-slate-700",
    shoulder: "bg-slate-200 dark:bg-slate-700",
    text: "text-white",
  },
  ["bg-emerald-500"]: {
    bg: "bg-emerald-50 dark:bg-emerald-900",
    transparent: "bg-emerald-500/5 dark:bg-emerald-500/10",
    gradientTop: "from-emerald-400 dark:from-emerald-600",
    gradientBottom: "to-emerald-600 dark:to-emerald-700",
    shoulder: "bg-emerald-200 dark:bg-emerald-700",
    text: "text-white",
  },
  ["bg-cyan-500"]: {
    bg: "bg-cyan-50 dark:bg-cyan-900",
    transparent: "bg-cyan-500/5 dark:bg-cyan-500/10",
    gradientTop: "from-cyan-400 dark:from-cyan-600",
    gradientBottom: "to-cyan-600 dark:to-cyan-700",
    shoulder: "bg-cyan-200 dark:bg-cyan-700",
    text: "text-white",
  },
  ["bg-sky-500"]: {
    bg: "bg-sky-50 dark:bg-sky-900",
    transparent: "bg-sky-500/5 dark:bg-sky-500/10",
    gradientTop: "from-sky-400 dark:from-sky-600",
    gradientBottom: "to-sky-600 dark:to-sky-700",
    shoulder: "bg-sky-200 dark:bg-sky-700",
    text: "text-white",
  },
  ["bg-violet-500"]: {
    bg: "bg-violet-50 dark:bg-sky-900",
    transparent: "bg-violet-500/5 dark:bg-violet-500/10",
    gradientTop: "from-violet-400 dark:from-violet-600",
    gradientBottom: "to-violet-600 dark:to-violet-700",
    shoulder: "bg-violet-200 dark:bg-violet-700",
    text: "text-white",
  },
  ["bg-fuchsia-500"]: {
    bg: "bg-fuchsia-50 dark:bg-fuchsia-900",
    transparent: "bg-fuchsia-500/5 dark:bg-fuchsia-500/10",
    gradientTop: "from-fuchsia-400 dark:from-fuchsia-600",
    gradientBottom: "to-fuchsia-600 dark:to-fuchsia-700",
    shoulder: "bg-fuchsia-200 dark:bg-fuchsia-700",
    text: "text-white",
  },
  ["bg-rose-500"]: {
    bg: "bg-rose-50 dark:bg-rose-900",
    transparent: "bg-rose-500/5 dark:bg-rose-500/10",
    gradientTop: "from-rose-400 dark:from-rose-600",
    gradientBottom: "to-rose-600 dark:to-rose-700",
    shoulder: "bg-rose-200 dark:bg-rose-700",
    text: "text-white",
  },
  ["bg-seagrass"]: {
    bg: "bg-seagrass/10 dark:bg-seagrass/20",
    transparent: "bg-seagrass/5 dark:bg-seagrass/10",
    gradientTop: "from-seagrass/80",
    gradientBottom: "to-seagrass",
    shoulder: "bg-seagrass/30 dark:bg-seagrass/50",
    text: "text-white",
  },
  ["bg-pomegranate"]: {
    bg: "bg-pomegranate/10 dark:bg-pomegranate/20",
    transparent: "bg-pomegranate/5 dark:bg-pomegranate/10",
    gradientTop: "from-pomegranate/80",
    gradientBottom: "to-pomegranate",
    shoulder: "bg-pomegranate/30 dark:bg-pomegranate/50",
    text: "text-white",
  },
  ["bg-carrot"]: {
    bg: "bg-carrot/10 dark:bg-carrot/20",
    transparent: "bg-carrot/5 dark:bg-carrot/10",
    gradientTop: "from-carrot/80",
    gradientBottom: "to-carrot",
    shoulder: "bg-carrot/30 dark:bg-carrot/50",
    text: "text-white",
  },
  ["bg-midnight-blue"]: {
    bg: "bg-midnight-blue/10 dark:bg-midnight-blue/20",
    transparent: "bg-midnight-blue/5 dark:bg-midnight-blue/10",
    gradientTop: "from-midnight-blue/80",
    gradientBottom: "to-midnight-blue",
    shoulder: "bg-midnight-blue/30 dark:bg-midnight-blue/50",
    text: "text-white",
  },
  ["bg-alizarin"]: {
    bg: "bg-alizarin/10 dark:bg-alizarin/20",
    transparent: "bg-alizarin/5 dark:bg-alizarin/10",
    gradientTop: "from-alizarin/80",
    gradientBottom: "to-alizarin",
    shoulder: "bg-alizarin/30 dark:bg-alizarin/50",
    text: "text-white",
  },
  ["bg-turquoise"]: {
    bg: "bg-turquoise/10 dark:bg-turquoise/20",
    transparent: "bg-turquoise/5 dark:bg-turquoise/10",
    gradientTop: "from-turquoise/80",
    gradientBottom: "to-turquoise",
    shoulder: "bg-turquoise/30 dark:bg-turquoise/50",
    text: "text-white",
  },
  ["bg-wisteria"]: {
    bg: "bg-wisteria/10 dark:bg-wisteria/20",
    transparent: "bg-wisteria/5 dark:bg-wisteria/10",
    gradientTop: "from-wisteria/80",
    gradientBottom: "to-wisteria",
    shoulder: "bg-wisteria/30 dark:bg-wisteria/50",
    text: "text-white",
  },
  ["bg-sienna"]: {
    bg: "bg-sienna/10 dark:bg-sienna/20",
    transparent: "bg-sienna/5 dark:bg-sienna/10",
    gradientTop: "from-sienna/80",
    gradientBottom: "to-sienna",
    shoulder: "bg-sienna/30 dark:bg-sienna/50",
    text: "text-white",
  },
  ["bg-cobalt"]: {
    bg: "bg-cobalt/10 dark:bg-cobalt/20",
    transparent: "bg-cobalt/5 dark:bg-cobalt/10",
    gradientTop: "from-cobalt/80",
    gradientBottom: "to-cobalt",
    shoulder: "bg-cobalt/30 dark:bg-cobalt/50",
    text: "text-white",
  },
  ["bg-magenta"]: {
    bg: "bg-magenta/10 dark:bg-magenta/20",
    transparent: "bg-magenta/5 dark:bg-magenta/10",
    gradientTop: "from-magenta/80",
    gradientBottom: "to-magenta",
    shoulder: "bg-magenta/30 dark:bg-magenta/50",
    text: "text-white",
  },
  ["bg-mauve"]: {
    bg: "bg-mauve/10 dark:bg-mauve/20",
    transparent: "bg-mauve/5 dark:bg-mauve/10",
    gradientTop: "from-mauve/80",
    gradientBottom: "to-mauve",
    shoulder: "bg-mauve/30 dark:bg-mauve/50",
    text: "text-white",
  },
  ["bg-olive"]: {
    bg: "bg-olive/10 dark:bg-olive/20",
    transparent: "bg-olive/5 dark:bg-olive/10",
    gradientTop: "from-olive/80",
    gradientBottom: "to-olive",
    shoulder: "bg-olive/30 dark:bg-olive/50",
    text: "text-white",
  },
  ["bg-crimson"]: {
    bg: "bg-crimson/10 dark:bg-crimson/20",
    transparent: "bg-crimson/5 dark:bg-crimson/10",
    gradientTop: "from-crimson/80",
    gradientBottom: "to-crimson",
    shoulder: "bg-crimson/30 dark:bg-crimson/50",
    text: "text-white",
  },
};

/**
 * Returns the palette object for a given swatch string (e.g. "bg-orange-500").
 * If the swatch is not found, returns undefined.
 */
export function getPaletteBySwatch(
  swatch: string,
  options?: { ignoreDiscoMode?: boolean; discoModeEnabled?: boolean },
): PaletteEntry | undefined {
  const ignoreDiscoMode = options?.ignoreDiscoMode ?? false;
  const discoModeEnabled = options?.discoModeEnabled ?? true;

  if (ignoreDiscoMode || !discoModeEnabled) {
    return palette["bg-slate-500"];
  }

  if (swatch in palette) {
    return palette[swatch as Swatch];
  }
  return undefined;
}
